import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-metodika-retry-button',
  template: `
    <button type="button"
            class="btn btn-outline-danger btn-sm ms-2 fw-bold"
            [disabled]="loading"
            (click)="handleClick($event)">
      <i *ngIf="!loading" class="bi bi-arrow-repeat me-1"></i>
      <ng-content></ng-content>
    </button>
  `
})
export class RetryButtonComponent {
  @Input() loading = false;
  @Output() retry = new EventEmitter<Event>();

  handleClick(event: Event) {
    event.stopPropagation();
    this.retry.emit(event);
  }
}